import React from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';

import { gameStore } from '../../../../../store/gameStore';

import PayTableSymbolsOddsWr from './payTableSymbolOddsWr';

const oddsInfoEnumWeb = [
  { id: 0, oddX: 15, oddContainerY: 25, oddsContainerX: 277, oddsContainerY: 585 },
  { id: 1, oddX: 15, oddContainerY: 25, oddsContainerX: 507, oddsContainerY: 585 },
  { id: 2, oddX: 15, oddContainerY: 25, oddsContainerX: 737, oddsContainerY: 585 },
  { id: 3, oddX: 15, oddContainerY: 25, oddsContainerX: 967, oddsContainerY: 585 },
  { id: 7, oddX: 15, oddContainerY: 25, oddsContainerX: 1197, oddsContainerY: 585 },
  { id: 8, oddX: 15, oddContainerY: 25, oddsContainerX: 1170, oddsContainerY: 217 },
  { id: 9, oddX: 15, oddContainerY: 25, oddsContainerX: 404, oddsContainerY: 217 },
];

const PayTableSymbolsOdds = observer(() => {
  const { oddsInfo } = gameStore;

  return (
    <Container name='PayTableOddsContainer'>
      {oddsInfoEnumWeb.map((item, index) => {
        return (
          <PayTableSymbolsOddsWr key={item.id} item={item} index={index} oddsInfo={oddsInfo} />
        );
      })}
    </Container>
  );
});

export default PayTableSymbolsOdds;
